export default "__VITE_ASSET__Yz3rgqrl__"